var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolfigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "31.972px",
    height: "48px",
    viewBox: "0 0 31.972 48",
    enableBackground: "new 0 0 31.972 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h32v47.999H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M16,24c0-4.418,3.582-8,8-8c4.419,0,8,3.582,8,8c0,4.418-3.581,8-8,8C19.582,32,16,28.418,16,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M0,39.999C0,35.582,3.582,32,8,32h8v7.999C16,44.418,12.418,48,8,48C3.582,48,0,44.418,0,39.999z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M16,0v16h8c4.419,0,8-3.582,8-8c0-4.418-3.581-8-8-8H16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M0,8c0,4.418,3.582,8,8,8h8V0H8C3.582,0,0,3.582,0,8L0,8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M0,24c0,4.418,3.582,8,8,8h8V16H8C3.582,16,0,19.582,0,24L0,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolfigma);
export default __webpack_public_path__ + "static/media/toolfigma.6b2acfab2885a45a01282d87312cd597.svg";
export { ForwardRef as ReactComponent };